import { Box, styled } from "@mui/material";

export const BodyWrapper = styled(Box)`
  position: relative;
  height: 100%;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
`;

export const VideoWrapper = styled(Box)`
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100%;
  width: 100%;
`;

export const StyledVideo = styled("video")`
  height: 82vh;
  width: auto;
  max-width: 100%;
  border-radius: 12px;
  background: #000;
  object-fit: contain;
`;
